// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-m_hr","advertDetailParameterList__header":"c-m_hs","advertDetailParameterList__list":"c-m_ht"};